import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Regex from "../utilities/regex";
import { FormGroup, FormFeedback, Input, Label, Row, Form } from "reactstrap";
import { toast } from "react-toastify";
import { push } from "connected-react-router";
import bcrypt from "bcryptjs";
import { getById } from "../firebase/methods";
import { hideLoader, showLoader } from "../redux/actions/app-action-types";

import { updatePassword } from "../firebase/methods";

function ChangePassword() {
  const [initialValues, setInitialValues] = useState({
      oldPassword: "",
      newPassword: "",
      confirmPassword: "",
    }),
    [errors, setErrors] = useState({
      confirmPassword: false,
      newPassword: false,
      oldPassword: false,
      oldPasswordError: "",
      newPasswordError: "",
      confirmPasswordError: "",
    });

  const dispatch = useDispatch();
  const session = useSelector((state) => state.session.user);

  const onHandleChange = ({ target: { name, value } }) => {
    setErrors({
      ...errors,
      [name]: false,
    });

    setInitialValues({
      ...initialValues,
      [name]: value,
    });
  };

  const onSubmit = async (e) => {
    e.preventDefault();
    const { oldPassword, newPassword, confirmPassword } = initialValues;
    try {
      const user = await getById("users", session.uid);
      // console.log("User :", user);
      if (!oldPassword.trim()) {
        setErrors({
          ...errors,
          oldPassword: true,
          oldPasswordError: "Please enter a valid password.",
        });
        return;
      }

      if (!Regex.password(newPassword.trim())) {
        setErrors({
          ...errors,
          newPassword: true,
          newPasswordError:
            "Please enter a valid password with 08-16 characters long and should be alphanumeric.",
        });
        return;
      }
      if (!confirmPassword.trim()) {
        setErrors({
          ...errors,
          confirmPassword: true,
          confirmPasswordError: "Please confirm your password.",
        });

        return;
      }

      if (newPassword.trim() !== confirmPassword.trim()) {
        setErrors({
          ...errors,
          confirmPassword: true,
          confirmPasswordError: "Password & confirm password doesn't match.",
        });

        return;
      }

      // console.log("Old pass: ", oldPassword, user.password);

      const isPasswordMatching = await bcrypt.compare(
        oldPassword,
        user.password
      );
      if (!isPasswordMatching) {
        toast.error("Invalid old password");
      } else {
        dispatch(showLoader());
        await updatePassword(newPassword);
        dispatch(hideLoader());
        toast.success("Password updated successfully");
        dispatch(push("/dashboard"));
      }
    } catch (error) {
      // console.log(error);
      toast.error(error.message);
      dispatch(hideLoader());
    }
  };

  return (
    <div className="mainContentWrapper">
      <div className="dashContentHeader">
        <h5 className="dashHeading mb-0">My Account</h5>
      </div>

      <div className="dashboardCardRow ">
        <div className="col-xl-6 col-lg-10 p-0">
          {" "}
          <h3 className="pwd-heading ">Change Password</h3>
          <hr />
        </div>
        <Form
          className="mg-login admin-pass mt-5 col-xl-6 col-lg-10 p-4 bg-white"
          onSubmit={onSubmit}
        >
          <h2 className="dashheader-title mb-4">Password Settings</h2>
          <Row>
            <div className="col-md-6 mb-4">
              <FormGroup>
                <Label htmlFor="oldPassword" className="email">
                  Old Password <span className="astrik">*</span>
                </Label>
                <Input
                  name="oldPassword"
                  className="form-control"
                  placeholder="Old password"
                  type="password"
                  value={initialValues.oldPassword}
                  invalid={errors.oldPassword}
                  onChange={onHandleChange}
                />
                <FormFeedback>{errors.oldPasswordError}</FormFeedback>
              </FormGroup>
            </div>
            <div className="col-md-6 mb-4 ">
              {" "}
              <FormGroup>
                <Label htmlFor="newPassword">New Password <span className="astrik">*</span> </Label>
                <Input
                  name="newPassword"
                  className="form-control"
                  placeholder="New password"
                  type="password"
                  value={initialValues.newPassword}
                  invalid={errors.newPassword}
                  onChange={onHandleChange}
                />
                <FormFeedback>{errors.newPasswordError}</FormFeedback>
              </FormGroup>
            </div>
            <div className="col-md-6 mb-3">
              <FormGroup>
                <Label htmlFor="confirmPassword" className="email">
                  Confirm New Password <span className="astrik">*</span>
                </Label>
                <Input
                  name="confirmPassword"
                  className="form-control emailInput"
                  placeholder="Retype Password"
                  type="password"
                  value={initialValues.confirmPassword}
                  invalid={errors.confirmPassword}
                  onChange={onHandleChange}
                />
                <FormFeedback>{errors.confirmPasswordError}</FormFeedback>
              </FormGroup>
            </div>
          </Row>
          <button className=" sub-button" type="submit">
            Save Changes
          </button>
        </Form>
      </div>
    </div>
  );
}

export default ChangePassword;
